/* RR · Bandeau annonce : un seul message à la fois, sur une ligne, en rotation.
   Pause au survol, au focus clavier et quand l'onglet est en arrière-plan.
   Dans l'éditeur de thème, cliquer sur un bloc « Message » l'affiche et met la rotation en pause. */
(function(){
  if (!window.customElements || customElements.get('rr-announce-rotator')) return;

  class RrAnnounceRotator extends HTMLElement {
    connectedCallback(){
      var self = this;
      this.slides = Array.prototype.filter.call(this.children, function(el){ return el.hasAttribute('data-slide'); });
      this.i = 0;
      this.slides.forEach(function(s, j){ if (s.classList.contains('is-on')) self.i = j; });
      this.ms = Math.max(2, parseFloat(this.dataset.speed) || 4.5) * 1000;
      this.holds = {};

      /* Une seule ligne : si un message est trop long pour l'écran, on réduit un peu sa taille */
      this._fit = function(){ self.fit(); };
      if ('ResizeObserver' in window) {
        this._w = -1;
        this._ro = new ResizeObserver(function(){ var w = self.clientWidth; if (w !== self._w) { self._w = w; self.fit(); } });
        this._ro.observe(this);
      } else {
        window.addEventListener('resize', this._fit);
      }
      if (document.fonts) {
        if (document.fonts.ready) document.fonts.ready.then(this._fit);
        if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', this._fit);
      }
      this.fit();

      if (this.slides.length < 2) return;
      var hold = function(k, on){ return function(){ self.hold(k, on); }; };
      this.addEventListener('pointerenter', hold('hover', true));
      this.addEventListener('pointerleave', hold('hover', false));
      this.addEventListener('focusin', hold('focus', true));
      this.addEventListener('focusout', hold('focus', false));
      this._vis = function(){ self.hold('hidden', document.hidden); };
      document.addEventListener('visibilitychange', this._vis);
      this._sel = function(e){ var j = self.slides.indexOf(e.target); if (j < 0) return; self.go(j); self.hold('editor', true); };
      this._desel = function(e){ if (self.slides.indexOf(e.target) >= 0) self.hold('editor', false); };
      document.addEventListener('shopify:block:select', this._sel);
      document.addEventListener('shopify:block:deselect', this._desel);
      this._vis();
    }

    disconnectedCallback(){
      clearTimeout(this._t);
      if (this._ro) this._ro.disconnect(); else window.removeEventListener('resize', this._fit);
      if (document.fonts && document.fonts.removeEventListener) document.fonts.removeEventListener('loadingdone', this._fit);
      if (this._vis) document.removeEventListener('visibilitychange', this._vis);
      if (this._sel) document.removeEventListener('shopify:block:select', this._sel);
      if (this._desel) document.removeEventListener('shopify:block:deselect', this._desel);
    }

    hold(k, on){
      if (on) this.holds[k] = 1; else delete this.holds[k];
      this.schedule();
    }

    schedule(){
      var self = this;
      clearTimeout(this._t);
      if (Object.keys(this.holds).length) return;
      this._t = setTimeout(function(){ self.next(); }, this.ms);
    }

    /* Un compte à rebours terminé (ou pas encore affiché) est sauté */
    usable(s){
      var cd = s.querySelector('rr-countdown');
      if (cd && cd.hidden) return false;
      return s.textContent.trim() !== '';
    }

    next(){
      var n = this.slides.length;
      for (var k = 1; k < n; k++) {
        var j = (this.i + k) % n;
        if (this.usable(this.slides[j])) { this.go(j); break; }
      }
      this.schedule();
    }

    go(j){
      if (j === this.i || !this.slides[j]) return;
      var cur = this.slides[this.i], nxt = this.slides[j];
      clearTimeout(cur._rrOut); clearTimeout(nxt._rrOut);
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      cur.setAttribute('aria-hidden', 'true'); cur.setAttribute('inert', '');
      nxt.classList.remove('is-out'); nxt.classList.add('is-on');
      nxt.removeAttribute('aria-hidden'); nxt.removeAttribute('inert');
      cur._rrOut = setTimeout(function(){ cur.classList.remove('is-out'); }, 700);
      this.i = j;
      this.fitOne(nxt);
    }

    fitOne(s){
      var t = s.querySelector('.rr-announce__txt');
      if (!t) return;
      t.style.fontSize = '';
      var w = s.clientWidth, sw = t.scrollWidth;
      if (w && sw > w + 1) {
        var fs = parseFloat(getComputedStyle(t).fontSize);
        t.style.fontSize = Math.max(9, Math.floor(fs * w / sw * 0.98 * 10) / 10) + 'px';
      }
    }

    fit(){
      var self = this;
      this.slides.forEach(function(s){ self.fitOne(s); });
    }
  }

  customElements.define('rr-announce-rotator', RrAnnounceRotator);
})();
